/**
 * Gdzie postawić okienko podglądu klatki, żeby nie wyszło za kadr.
 *
 * Podgląd jest wyśrodkowany nad wskazanym punktem paska (`left: X%` plus przesunięcie
 * o połowę własnej szerokości). Przy końcach paska to znaczy, że połowa okienka
 * wychodzi za obraz — a kontener kadru ma `overflow: hidden`, więc podgląd jest tam
 * **ucięty**: przewijając do pierwszej albo ostatniej minuty odcinka widz dostaje pół
 * miniatury i obciętą godzinę, czyli dokładnie w miejscach, w których celuje najczęściej
 * (początek openingu, scena po napisach).
 *
 * Rozwiązanie jest w CSS, nie w pomiarze: `clamp()` zna szerokość paska jako `100%`,
 * więc nie musimy jej mierzyć ani trzymać w stanie. Środek okienka może wejść najwyżej
 * do połowy jego szerokości od każdej krawędzi.
 */

export function previewLeft(ratio: number, previewWidthPx: number): string {
  const clamped = Math.min(1, Math.max(0, ratio));
  const percent = `${(clamped * 100).toFixed(3)}%`;
  const half = Math.round(previewWidthPx / 2);

  /**
   * Okienko szersze od paska nie ma jak się zmieścić — wtedy zostaje wyśrodkowane.
   * Bez tego `clamp()` dostałby dolną granicę większą od górnej, a to zachowanie
   * zależy od przeglądarki: część wybiera dolną, część górną.
   */
  if (half <= 0) return percent;
  return `clamp(min(${half}px, 50%), ${percent}, max(calc(100% - ${half}px), 50%))`;
}
